export default "__VITE_ASSET__4bhl9hKf__"